import React from 'react';
import DropdownButton from '../dropdowns/DropdownButton';

const FilterDistrict = props => {
    const { toggleCongressDropdowns, congress, isMobile, districtInfo } = props; 

    const propsValue = `congressDistrict-${congress.filterDistrict.congressDistrict}`;

    // need to check parent container state.
    // since we closing the state listing, we need to shorten the container panel height
    const districtFilterStatus = document.getElementsByClassName('congress-district-dropdowns open');
    if (districtFilterStatus.length === 1) {
        districtFilterStatus[0].classList.remove('district-longer');
    }

    return (
        <DropdownButton
            name={congress.selected.districtName}
            callFunction={toggleCongressDropdowns}
            callVal={propsValue}
            chevron="down"
            active={congress.selected.stateName !== 'State'}
            isMobile={isMobile}
            districtInfo={districtInfo}
            id="district-filter"
        />
    );
};

export default FilterDistrict;
